import { createSelector } from 'reselect'
import entryDataSelector from './entryDataSelector'

const equipmentGroupOrderingSelector = createSelector(
    entryDataSelector,
    (entryData): string[] => entryData.equipmentGroupOrdering,
)

export default equipmentGroupOrderingSelector
